import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useProductDetail(id) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/products/${id}`,
          method: "GET",
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProductDetail;
